export interface TransactionFilterOption { value: string; label: string; details?: string }
export interface SystemTransactionFilters {
	entity: TransactionFilterOption[]
	tx_type: TransactionFilterOption[]
	direction: TransactionFilterOption[]
	status: TransactionFilterOption[]
	date_period: TransactionFilterOption[]
	companies: Array<{ value: string; label: string; type: string; status: string }>
	issuers: Array<{ value: number; label: string; provider_code: string }>
	teams: Array<{ value: string; label: string; status: string }>
	users: Array<{ value: string; label: string; email: string; role: string; team_uid: string; team_name: string }>
	cards: Array<{ value: string; label: string; mask: string; bin: string; status: string; user_uid: string; team_uid: string; issuer: number; issuer_label: string }>
	bins: TransactionFilterOption[]
}
export type SystemTransactionFilter = Record<string, string | number | boolean | undefined> & { company_uid?: string; all_companies?: boolean; page?: number; limit?: number }
export interface SystemTransactionPreset {
	uid: string; name: string; date_period: string; date_from: string; date_to: string
	author_uid: string; author_name: string; created_at: string; updated_at: string; company_uid: string
	filter: SystemTransactionFilter
}
interface TransactionParty { account_id: number; kind: string; name?: string; card_mask?: string; issuer_label?: string }
export interface SystemTransaction {
	id: number; operation_id: number | null; company_uid: string; company_name: string
	amount: number; balance: number; currency: string; description: string; created_at: string
	status: string; direction: string; operation_type: string; issuer_label?: string
	card_uid?: string; card_name?: string; card_mask?: string; buyer_name?: string; team_name?: string
	from?: TransactionParty; to?: TransactionParty; merchant?: { name: string | null }
	/** Fee rows only; `label` is the ready caption from the backend. */
	charge?: { fee_code: string; charged_by: "us" | "issuer"; label?: string }
}
export interface SystemTransactionsResponse {
	transactions: SystemTransaction[]
	pagination: { total: number; page: number; limit: number; pages: number }
	balances: Record<string, { income: number; expense: number }>
	totals: Record<string, { settled: number; pending: number; commission: number; returned: number; spent?: number; refund?: number; deposit?: number; other?: number }>
	truncated?: boolean
	scanned: { companies: number; accounts: number; elapsed_ms: number }
}

const dateString = (date: Date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
export const transactionPeriodDates = (period: string, now = new Date()): { from?: string; to?: string } => {
	if (period === "all_time" || period === "custom") return {}
	const start = new Date(now.getFullYear(), now.getMonth(), now.getDate())
	const end = new Date(start)
	if (period === "yesterday") { start.setDate(start.getDate() - 1); end.setDate(end.getDate() - 1) }
	else if (/^last_(7|30|90)_days$/.test(period)) start.setDate(start.getDate() - Number(period.split("_")[1]) + 1)
	else if (period === "this_week" || period === "last_week") {
		start.setDate(start.getDate() - (start.getDay() + 6) % 7)
		if (period === "last_week") { start.setDate(start.getDate() - 7); end.setTime(start.getTime()); end.setDate(end.getDate() + 6) }
	} else if (period === "this_month") start.setDate(1)
	else if (period === "last_month") { start.setDate(1); start.setMonth(start.getMonth() - 1); end.setDate(0) }
	else if (period === "this_year") { start.setMonth(0, 1) }
	else if (period !== "today") throw new Error("Choose a supported date period or enter custom dates.")
	return { from: dateString(start), to: dateString(end) }
}
